import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@loot-os/ui/components/alert-dialog";

import type { UnsavedChangesGuard } from "../lib/useUnsavedChangesGuard";

/**
 * The question `useUnsavedChangesGuard` asks when a navigation would leave unsaved changes:
 * Keep editing (also Escape), Discard and leave, and Save and leave when the page can save.
 * An alert dialog, so focus moves into it and stays there until it is answered.
 */
export function UnsavedChangesDialog({ guard }: { guard: UnsavedChangesGuard }) {
  return (
    <AlertDialog
      open={guard.blocked}
      onOpenChange={(open) => {
        if (!open && !guard.saving) guard.keepEditing();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Leave without saving?</AlertDialogTitle>
          <AlertDialogDescription>This page has unsaved changes.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={guard.saving}>Keep editing</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={guard.saving}
            onClick={guard.discardAndLeave}
          >
            Discard and leave
          </AlertDialogAction>
          {guard.canSave && (
            <AlertDialogAction disabled={guard.saving} onClick={() => void guard.saveAndLeave()}>
              {guard.saving ? "Saving…" : "Save and leave"}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
